import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useState, useEffect } from 'react';
import Element from 'src/components/element';
import View from 'src/components/view';

function EsqueciSenha() {
  const crud = { changed: {}, data: {} };
  const data = {};
  const view = {};

  window.view = view;

  const user = JSON.parse(localStorage.getItem('user'));

  // Se tiver algum usuário logado, redireciona para a home
  if (user?.id) {
    window.location.href = '/home';
  }

  const dicionario = {
    pt: {
      email_recuperacao: 'Informe o e-mail para recuperação',
      recuperar_acesso: 'RECUPERAR ACESSO',
    },
    en: {
      email_recuperacao: 'Enter email for recovery',
      recuperar_acesso: 'RECOVER ACCESS',
    },
    es: {
      email_recuperacao: 'Ingrese correo electrónico para recuperación',
      recuperar_acesso: 'RECUPERAR ACCESO',
    },
  };

  let navigatorLanguage = (navigator.language || navigator.userLanguage || 'pt').split('-')[0].toLowerCase();
  if (!dicionario[navigatorLanguage]) {
    navigatorLanguage = 'pt';
  }

  let login = {
    styleClass: 'ui-login-panel ui-login-panel-' + navigatorLanguage,
    elements: {
      left: {
        cols: 3,
        elements: {
          logo_ngs: { type: 'img', value: 'static/img/logo_ngs.png', center: true },
        },
      },
      center: {
        cols: 6,
        elements: {
          logar: {
            type: 'form',
            elements: {
              logo: { type: 'img', value: 'static/img/logo_login.png', center: true },
              voltar: { type: 'link', icon: 'fa fa-arrow-left', href: 'login' },
              login: {
                type: 'email',
                label: dicionario[navigatorLanguage].email_recuperacao,
                translated: true,
                name: 'login',
                title: 'Informe seu email',
              },
              btnLogar: {
                type: 'button',
                label: dicionario[navigatorLanguage].recuperar_acesso,
                translated: true,
                icon: '',
                styleClass: 'ui-btn-login',
                theme: 'secondary',
                click: {
                  url: 'recuperarSenha',
                  redirect: '/login',
                  method: 'POST',
                },
              },
            },
          },
        },
      },
      right: {
        cols: 3,
      },
    },
  };
  return (
    <View full={true}>
      <Element crud={crud} value={login} data={data} user={data} />
    </View>
  );
}

export default EsqueciSenha;
